<template>
  <div class="col-md-10 m-auto">
    <div>
      <div id="AgtSvcNotice">
        <h5 class="pl-15 pt-20">
          <i class="fas fa-exclamation-circle"></i>
          서비스 이용안내
        </h5>

        <ul class="fa-ul pb-20 pr-10 ft-1" id="AgtSvcInfo">
          <li>
            <span class="fa-li"> <i class="fas fa-caret-right"></i> </span>
            집비오는 부동산의 허위매물을 원천 차단하기 위하여, 한 명의
            공인중개사에게만 의뢰하는 전속중개계약을 체결한 매물만 노출이
            가능합니다.
          </li>
          <li>
            <span class="fa-li"> <i class="fas fa-caret-right"></i> </span>매물
            주소를 입력하시면, 건축물대장에 있는 정보가 자동으로 불러와집니다.
            (건축물대장상에 없는 내용은 직접 입력하실 수 있습니다.)
          </li>
          <li>
            <span class="fa-li"> <i class="fas fa-caret-right"></i> </span
            >등록하신 매물은 집비오의 검수 과정을 거쳐 노출됩니다. (등록 -> 검토
            -> 최종 노출)
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style>
/*div {
  font-size: 18px;
}*/
#AgtSvcNotice {
  background-color: #c3d1fd30;
  margin-top: 2%;
  margin-bottom: 1%;
}

#AgtSvcNotice h5 {
  color: #797979;
}

#AgtSvcInfo li {
  list-style: none;
  color: #797979;
}
</style>
